import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { hostname } from "../../data";
import { makeRequest } from "../../api/api";
export const newsRoomData = createAsyncThunk(

  'newsroom/getnewsroom',
  async () => {
    const request = await makeRequest("get", "/api/get_news/")
    const response = await request.data.data
    return response
  }
)

export const uploadNews = createAsyncThunk(
  'newsRoom/uploadnews',
  async (params) => {
    const request = await makeRequest("post", `api/publish_article/`, params)
    const response = await request.data.data
    return response
  }
)

export const deleteNews = createAsyncThunk(
  'newsRoom/deletenews',
  async (id) => {
    const request = await makeRequest("delete", `api/delete_news/?id=${id}`)
    const response = await request.data.data
    return response
  }
)

export const editNews = createAsyncThunk(
  'newsRoom/editnews',
  async (params) => {
    const request = await makeRequest("put", `api/edit_news/`, params)
    const response = await request.data.data
    return response
  }
)

export const spotPriceGraphData = createAsyncThunk(
  'newsroom/getspotPrice',
  async (timeRange, { rejectWithValue }) => {
    try {
      const request = await makeRequest(
        "get",
        `${hostname}api/get_spot/?time_range=${timeRange}`
      );

      if (Array.isArray(request.data.graph)) {
        return request.data.graph;
      }

      return [];

    } catch (error) {
      return rejectWithValue(
        error?.response?.data || "Failed to fetch spot price data"
      );
    }
  }
);


export const newsRoomSortingData = createAsyncThunk(
  'sortednewsroom/getsortednews',
  async (sortDirection = 'asc') => {
    const request = await makeRequest("get", `/api/get_news/?sort=${sortDirection}`)
    const response = await request.data.data
    return response
  }
)

export const newsRoomSearchData = createAsyncThunk(
  'searchnewsroom/getsearchednews',
  async (input_keyword) => {
    const request = await makeRequest("get", `api/get_news/?keyword=${input_keyword}`)
    const response = await request.data.data
    return response
  }
)

export const updateLikestatus = createAsyncThunk(
  'newsRoom/likenews',
  async (params) => {
    const request = await makeRequest("post", `api/like/`, params)
    const response = await request.data.data
    return response
  }
)
export const spotPricePost = createAsyncThunk(
  'newsRoom/spotPrice',
  async (params, { rejectWithValue }) => {
    try {
      const request = await makeRequest("post", `api/update_spot_price/`, params);

      if (!request || !request.data) {
        return null;
      }

      return request.data.data ?? request.data ?? null;

    } catch (error) {
      console.error("POST SPOT API FAILED:", error);
      return rejectWithValue(
        error?.response?.data || "Failed to update spot price"
      );
    }
  }
);

export const shareDailyEmail = createAsyncThunk(
  'newsRoom/shareDailyEmail',
  async (formData, { rejectWithValue }) => {
    try {
      const request = await makeRequest("post", "api/share_daily_email/", formData);
      return request.data ?? true;
    } catch (error) {
      console.error("SHARE DAILY EMAIL FAILED:", error);
      return rejectWithValue(error?.response?.data || "Failed to send daily email");
    }
  }
);

export const shareWeeklyEmail = createAsyncThunk(
  'newsRoom/shareWeeklyEmail',
  async (formData, { rejectWithValue }) => {
    try {
      const request = await makeRequest("post", "api/share_weekly_email/", formData);
      return request.data ?? true;
    } catch (error) {
      console.error("SHARE WEEKLY EMAIL FAILED:", error);
      return rejectWithValue(error?.response?.data || "Failed to send weekly email");
    }
  }
);


export const shareFuelEuEmail = createAsyncThunk(
  "newsroom/shareFuelEuEmail",
  async (formData, { rejectWithValue }) => {
    try {
      const request = await makeRequest("post", "api/share_fueleu_email/", formData);
      return request.data ?? true;
    } catch (error) {
      console.error("SHARE FEULEU EMAIL FAILED:", error);
      return rejectWithValue(error?.response?.data || "Failed to send FeulEU email");
    }
  }
);


export const fuelEuData = createAsyncThunk(
  'newsroom/getfueleu',
  async (_, { rejectWithValue }) => {
    try {
      const request = await makeRequest("get", "api/fueleu/");
      return request.data?.data ?? request.data ?? [];
    } catch (error) {
      console.error("GET FUELEU API FAILED:", error);
      return rejectWithValue(
        error?.response?.data || "Failed to fetch FuelEU data"
      );
    }
  }
);

export const deleteFuelEuItem = createAsyncThunk(
  'newsroom/deleteFuelEu',
  async (id, { rejectWithValue }) => {
    try {
      const request = await makeRequest("delete", `api/delete/?news_id=${id}`);
      return { id, data: request.data };
    } catch (error) {
      console.error("DELETE FUELEU API FAILED:", error);
      return rejectWithValue(
        error?.response?.data || "Failed to delete FuelEU item"
      );
    }
  }
);

const newsRoomSlice = createSlice({
  name: "newsRoom",
  initialState: {
    status: 'idle',
    newsList: [],
    selectedNewsData: null,
    selectedNewsID: null,
    sortedNewsStatus: 'idle',
    searchedNewsStatus: 'idle',
    fuelEuList: [],
    fuelEuStatus: 'idle',
    selectedFuelEuData: null,
    selectedFuelEuID: null
  },
  reducers: {
    setSelectedNewsData: (state, action) => {
      state.selectedNewsData = action.payload
    },
    selectedNewsRoomID: (state, action) => {
      state.selectedNewsID = action.payload
    },
    setSelectedFuelEuData: (state, action) => {
      state.selectedFuelEuData = action.payload
    },
    selectedFuelEuRoomID: (state, action) => {
      state.selectedFuelEuID = action.payload
    },
    deleteSelectedNewsRoom: (state, action) => {
      const idToDelete = action.payload;
      state.newsList = state.newsList.filter(news => news.id !== idToDelete);
      if (state.selectedNewsID === idToDelete) {
        state.selectedNewsData = null;
        state.selectedNewsID = null;
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(newsRoomData.pending, (state) => {
        state.status = 'loading';
        state.newsList = []
      })
      .addCase(newsRoomData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.newsList = action.payload;
      })
      .addCase(newsRoomData.rejected, (state) => {
        state.status = 'failed';
        state.newsList = []
      })

      .addCase(newsRoomSortingData.pending, (state) => {
        state.sortedNewsStatus = 'loading';
      })
      .addCase(newsRoomSortingData.fulfilled, (state, action) => {
        state.sortedNewsStatus = 'succeeded';
        state.newsList = action.payload;
      })
      .addCase(newsRoomSortingData.rejected, (state) => {
        state.sortedNewsStatus = 'failed';
      })

      .addCase(newsRoomSearchData.pending, (state) => {
        state.searchedNewsStatus = 'loading';
      })
      .addCase(newsRoomSearchData.fulfilled, (state, action) => {
        state.searchedNewsStatus = 'succeeded';
        state.newsList = action.payload;
      })
      .addCase(newsRoomSearchData.rejected, (state) => {
        state.searchedNewsStatus = 'failed';
      })

      builder
.addCase(fuelEuData.pending, (state) => {
  state.fuelEuStatus = "loading";
 })
 .addCase(fuelEuData.fulfilled, (state, action) => {
   state.fuelEuStatus = "succeeded";
   state.fuelEuList = action.payload;
   if (action.payload?.length) {
     state.selectedFuelEuData = action.payload[0];
     state.selectedFuelEuID = action.payload[0].id;
   } else {
     state.selectedFuelEuData = null;
     state.selectedFuelEuID = null;
   }
 })
 .addCase(fuelEuData.rejected, (state, action) => {
   state.fuelEuStatus = "failed";
   state.fuelEuError = action.payload;
  });

      builder
.addCase(deleteFuelEuItem.fulfilled, (state, action) => {
  const idToDelete = action.payload.id;
  state.fuelEuList = state.fuelEuList.filter((item) => item.id !== idToDelete);
  if (state.selectedFuelEuID === idToDelete) {
    state.selectedFuelEuData = state.fuelEuList[0] || null;
    state.selectedFuelEuID = state.fuelEuList[0]?.id ?? null;
  }
 })
 .addCase(deleteFuelEuItem.rejected, (state, action) => {
   state.fuelEuError = action.payload;
  });

      builder
.addCase(shareFuelEuEmail.pending, (state) => {
  state.status = "loading";
 })
 .addCase(shareFuelEuEmail.fulfilled, (state, action) => {
   state.status = "succeeded";
 })
 .addCase(shareFuelEuEmail.rejected, (state, action) => {
   state.status = "failed";
   state.error  = action.payload;
  });


  },
})

// Reducer variables
export const { setSelectedNewsData, selectedNewsRoomID, deleteSelectedNewsRoom, setSelectedFuelEuData, selectedFuelEuRoomID } = newsRoomSlice.actions;

export default newsRoomSlice.reducer;